import { buildSubdomainOrigin } from '@/common/tenant-utils';

const ADMIN_CONSOLE_SUBDOMAIN = 'admin';

export function buildAdminConsoleDashboardUrl(tenantSlug: string) {
  return `${buildSubdomainOrigin(ADMIN_CONSOLE_SUBDOMAIN)}/${tenantSlug}/dashboard`;
}
